import React from "react";

import { faBarsFilter, faCalendarDays } from "@performyard/fontawesome/pro-regular-svg-icons";
import { Badge, ButtonStandard, Text } from "@performyard/py-components";

import AvatarGroup from "../../../../components/AvatarGroup";
import WorkspaceActionsDropdown from "./WorkspaceActionsDropdown";

interface WorkspaceDetailsHeaderProps {
	workspaceName: string;
	workspaceParticipants: Array<{ _id: string; name: string }>;
	activeFiltersCount: number;
	onFilterClick: () => void;
	onAddMeetingClick?: () => void;
	isAdmin?: boolean;
	hasExistingMeetings?: boolean;
	workspaceId: string;
	filters: Record<string, any>;
	sort: { name: string; direction: "asc" | "desc" };
	meetings?: Array<{ status: string }>;
}

const WorkspaceDetailsHeader = ({
	workspaceName,
	workspaceParticipants,
	activeFiltersCount,
	onFilterClick,
	onAddMeetingClick,
	isAdmin = false,
	hasExistingMeetings = false,
	workspaceId,
	filters,
	sort,
	meetings = [],
}: WorkspaceDetailsHeaderProps) => {
	return (
		<div>
			<div className="flex w-full flex-row items-center space-x-2 py-8">
				<div className="py-line-clamp-1" style={{ maxWidth: "1288px" }}>
					<Text size="heading-5" weight="semi-bold">
						{workspaceName}
					</Text>
				</div>
				<AvatarGroup employees={workspaceParticipants} maxLength={2} size={32} employeeNameTooltip={true} />
			</div>
			<div className="flex flex-row justify-between">
				<div className="relative">
					<ButtonStandard
						variant="outline"
						color="neutral"
						iconLeft={faBarsFilter}
						onClick={onFilterClick}
						disabled={!hasExistingMeetings && activeFiltersCount === 0}
					>
						Meeting Filters
					</ButtonStandard>
					{activeFiltersCount > 0 && <Badge count={activeFiltersCount} border />}
				</div>
				<div className="flex items-center space-x-2">
					{!isAdmin && onAddMeetingClick && (
						<ButtonStandard color="green" iconLeft={faCalendarDays} onClick={onAddMeetingClick}>
							Add Meeting
						</ButtonStandard>
					)}
					<WorkspaceActionsDropdown
						workspaceId={workspaceId}
						filters={filters}
						sort={sort}
						isAdmin={isAdmin}
						meetings={meetings}
					/>
				</div>
			</div>
		</div>
	);
};

export default WorkspaceDetailsHeader;
